const Sounds = {
  notificationSound: require('./files/notification_sound.mpeg').default,
}

export default Sounds
